export default "__VITE_ASSET__BWUtBA3P__"